import { render, staticRenderFns } from "./bookingFormatAddress.vue?vue&type=template&id=16eaba5f&scoped=true&"
import script from "./bookingFormatAddress.vue?vue&type=script&lang=js&"
export * from "./bookingFormatAddress.vue?vue&type=script&lang=js&"
import style0 from "./bookingFormatAddress.vue?vue&type=style&index=0&id=16eaba5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eaba5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16eaba5f')) {
      api.createRecord('16eaba5f', component.options)
    } else {
      api.reload('16eaba5f', component.options)
    }
    module.hot.accept("./bookingFormatAddress.vue?vue&type=template&id=16eaba5f&scoped=true&", function () {
      api.rerender('16eaba5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/bookingFormatAddress.vue"
export default component.exports